<template>
  <v-hover>
    <template v-slot:default="{hover}">
      <div class="pickup-point-component">
        <input
          v-if="selectable"
          @change="onChange"
          type="radio"
          :name="name"
          :value="item.id"
          class="radio-button"
          :checked="checked"
          :disabled="disabled"
        />
        <div
          class="pickup-point-content d-flex flex-column justify-space-between transition-swing"
          :class="{'pickup-point-content_hover': hover}"
        >
          <div class="d-flex align-start justify-space-between">
            <div class="d-flex flex-column">
              <span class="point-name">{{ item.name }}</span>
              <span class="address">{{ item.address }}</span>
            </div>

            <div class="checkmark d-flex align-center justify-center">
              <font-awesome-icon icon="check"/>
            </div>
          </div>

          <div class="pickup-point_footer">
            <div class="pickup-point_footer__left">
              <span class="metro" v-if="item.metro">
                <icon-metro />
                {{ item.metro }}
              </span>

              <span
                class="working-hours"
                :class="{'is-working-time': isWorkingTime}"
              >
                <font-awesome-icon class="working-hours__icon" icon="clock"/>
                {{ item.startTime }} - {{ item.endTime }}
              </span>
            </div>

            <div class="pickup-point_footer__right">
              <div class="pickup-point_footer__right">
                <slot :name="`right-bottom`" :item="item"/>
              </div>
            </div>

            <!-- Отдельной строкой на всю ширину карточки: левая колонка
                 ограничена 70%, длинная причина там обрезалась -->
            <filial-stop-label
              class="pickup-point_footer__stop"
              :filial-stop="item.filialStop"
            />
          </div>
        </div>
      </div>
    </template>
  </v-hover>
</template>

<script>
  // import IconMetro from '@/components/icons/IconMetro'

  import { isFilialWorkingTime } from '@/util/filialHelper'
  import FilialStopLabel from '@/components/stop-list/FilialStopLabel.vue'

  export default {
    name: 'PickupPoint',
    model: {
      prop: 'val',
      event: 'change',
    },
    components: {
      FilialStopLabel,
      // IconMetro,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number, Boolean],
      },
      item: {
        type: Object,
        default: () => ({}),
      },
      checked: Boolean,
      disabled: {
        type: Boolean,
        default: false,
      },
      selectable: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        val: '',
        isWorkingTime: false,
        checkInterval: null,
      }
    },
    methods: {
      onChange () {
        this.$emit('change', this.value)
      },
      checkWorkTime () {
        this.isWorkingTime = isFilialWorkingTime(this.item)
      },
    },
    created () {
      this.checkWorkTime()
      this.checkInterval = setInterval(this.checkWorkTime, 60000)
    },
    beforeDestroy () {
      clearInterval(this.checkInterval)
    },
  }
</script>

<style lang="less" scoped>
.pickup-point-component {
  position: relative;
  z-index: 0;
  line-height: 1.3;

  .radio-button {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    cursor: pointer;
    outline: none;
    border-radius: 10px;
    opacity: 0;

    &:checked ~ .pickup-point-content {
      background-color: @color-primary;

      .checkmark {
        visibility: visible;
      }

      .point-name,
      .address,
      .metro,
      .working-hours {
        color: #ffffff;
      }

      .metro,
      .working-hours {
        svg {
          ::v-deep {
            .fill-svg(#ffffff);
          }
        }
      }

      // На оранжевом фоне выбранной карточки розовый текст не читается -
      // знак остаётся фирменным, текст белеет
      ::v-deep .filial-stop-label {
        color: #ffffff;
      }
    }
  }

  .pickup-point-content {
    padding: 20px 17px 17px 20px;
    min-height: 213px;
    background-color: @color-secondary;
    box-shadow: 0 3px 6px #00000029;
    border-radius: 10px;
    transition: background-color 0.2s ease;

    &_hover {
      box-shadow: 0 6px 12px #00000029 !important;
    }
  }

  .point-name {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    margin-bottom: 26px;
    transition: color 0.2s ease;
    font-weight: bold;
  }

  .address {
    display: block;
    font-size: 14px;
    line-height: 21px;
    transition: color 0.2s ease;
  }

  .checkmark {
    background-color: #ffffff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    visibility: hidden;
    flex-shrink: 0;
    font-size: 18px;
    color: @color-primary;

    /*svg {
      width: 23px;
      height: 23px;
      .fill-svg(@color-primary);
    }*/
  }

  .metro {
    display: block;
    margin-bottom: 5px;
    transition: color 0.2s ease;

    svg {
      margin-right: 15px;
      font-size: 16px;
      line-height: 21px;

      ::v-deep {
        .fill-svg(@color-primary);
      }
    }
  }

  .working-hours {
    display: block;
    font-size: 14px;
    line-height: 14px;
    transition: color 0.2s ease;

    &__icon {
      color: @color-error;
      margin-right: 5px;
      font-size: 16px;
      line-height: 21px;
    }

    &.is-working-time {
      .working-hours__icon {
        color: @color-success;
      }
    }
  }

  .pickup-point_footer {

    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: space-between;

    &__left {
      max-width: 70%;
    }

    // Строка стопа уходит в свой ряд на всю ширину
    &__stop {
      flex: 0 0 100%;
    }

    &__right {

    }

  }

  .media-xl-max({
    .point-name {
      font-size: 1.1em;
    }

    .address {
      font-size: 13px;
    }

    .checkmark {
      width: 25px;
      height: 25px;
      font-size: 13px;
    }
  })

}
</style>
